<template>
    <div class="eml-emails-list">
        <div class="between-center mb">
            <h4 class="title subheading is-3">
                Emails
            </h4>
        </div>
        <compose-button />
        <br>
        <o-table :data="threads" :row-class="rowClass" @click="handleRowClick" class="eml-emails-list-table">
            <template>
                <o-table-column class="column-from"  field="from" #default="{ row }">
                    <span v-for="(item, key) in row.from_array" style="font-size: 17px;" :class="{ title: item.read }" :key="key">{{ item.name
                        }}{{
                            (row.from_array.length !== key + 1 &&
                                `,&nbsp;`) ||
                            ""
                        }}
                    </span>
                    &nbsp;
                    <span class="count">{{ row.from_names_count }}</span>
                </o-table-column>
                <o-table-column field="subject" sortable #default="{ row }">
                    <span class=" is-6">{{ row.subject }}</span>
                    &nbsp;-&nbsp;
                    <span class="snippet break-word" v-html="row.snippet" />
                    <div class="msg-attachments" v-if="row.files && row.files.length">
                        <span class="msg-attachment" v-for="(file, key) in row.files" :key="`files-${key}`"
                            @click.stop="handle_open_file(file)">
                            <a :href="file.path" target="_blank" @click.prevent.stop="handle_open_file(file)">{{
                                file.name }}
                            </a>
                        </span>
                    </div>
                </o-table-column>
                <o-table-column
                    field="date"
                    sortable
                    #default="{ row }"
                >
                    <div style="font-size: 17px;" class="title">{{ getDate(row.date)  }}</div>
                </o-table-column>
            </template>
            <template #headers>
            </template>
        </o-table>
        <o-modal :can-cancel="['escape', 'outside', 'button']" v-model:active="isPreviewModalActive"
            class="preview-modal" has-modal-card>
            <file-preview-modal :file="currentPreviewFile" />
        </o-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import FilePreviewModal from '../../../modules/emails/components/modals/FilePreviewModal';
import ComposeButton from '../../../modules/emails/compose/ComposeButton';
import { get_names_and_count } from '../../../modules/emails/gmail_api';

export default {
    components: {
        ComposeButton,
        FilePreviewModal,
    },

    data() {
        return {
            currentPreviewFile: null,
            isPreviewModalActive: false,
            messages: [],
        }
    },
    computed: {
        ...mapGetters([
        ]),

        threads() {
            const threads = []
            this.messages.forEach(message => {
                if (message.thread_id === message.message_id) {
                    threads.push(message)
                }
            })
            this.messages.forEach(message => {
                if (message.thread_id !== message.message_id) {
                    threads.forEach(thread => {
                        if (message.thread_id === thread.thread_id) {
                            thread.messages = thread.messages || []
                            thread.messages.push(message)
                        }
                    })
                }
            })
            threads.forEach(thread => {
                thread.messages = thread.messages || []
                const { count, from_array } = get_names_and_count([thread, ...thread.messages])
                thread.from_array = from_array
                thread.from_names_count = count
            })
            return threads
        }
    },
    methods: {
        ...mapActions(['fetchEmails',]),
        getDate(dateString) {
            const now = new Date()
            const date = new Date(dateString)
            const hours = (now.getTime() - date.getTime()) / (60 * 60 * 1000)
            if (hours < 24) {
                return moment(dateString).format('hh:mm A')
            }
            return moment(dateString).format('MMM DD')
        },
        handle_open_file(file) {
            this.currentPreviewFile = file
            this.isPreviewModalActive = true
        },
        handleRowClick(row) {
            this.$router.push({ name: "emails.view", params: { message_id: row.thread_id } })
        },
        init() {
            const reference_id = parseInt(this.$route.params.slug)
            const reference_type = this.$route.name === 'projects.show.emails' ? 'project' : 'proposal'
            this.fetchEmails({ reference_id, reference_type, withFiles: true }).then(data => {
                const { messages } = data
                this.messages = messages
            })
        },
        isRead(message) {
            if (message && Array.isArray(message.messages)) {
                return !message.messages.some(m => m.label_ids.includes('UNREAD'))
            }
            return false
        },
        rowClass(row) {
            return this.isRead(row) && 'read'
        },
    },
    mounted() {
        this.init()
    }
}
</script>

<style lang="sass">
.eml-emails-list
  .eml-emails-list-table
    .table-wrapper
      table
        thead
          display: none
        tr
          background: #fff
          box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(0, 0, 0, 0.1)
          td
            .title
              color: #202124
              font-size: 0.875rem
            &.column-from
              .count
                color: #5f6368
            &:last-child
              text-align: right
              white-space: nowrap
        tr.read
          background-color: rgba(242, 245, 245, 0.8)
          .title
            font-weight: 400
    .msg-attachments
      display: flex
      margin-top: 9px
      .msg-attachment
        align-items: center
        border-radius: 15px
        box-shadow: inset 0 0 0 1px rgba(100,121,143,0.302)
        box-sizing: border-box
        color: #5f6368
        display: flex
        height: 30px
        justify-content: center
        margin-right: 8px
        max-width: 160px
        min-width: 64px
        padding: 0 12px
        a
          overflow: hidden
          text-overflow: ellipsis
          white-space: nowrap
    .snippet
      color: #5f6368
      text-overflow: ellipsis
</style>